<template>
	<div class="body">
		<div class="main flex-column flex-center">
			<img class="logo" src="@/assets/image/login/logo.png">

			<div class="login flex-center">
				<div class="cover flex-center">
					<img src="@/assets/image/login/login.png">
				</div>
				<div class="form flex-grow">
					<div class="title flex-baseline">
						<h1>统一认证登录</h1>
						<p>TACS SSO</p>
					</div>

					<div v-if="loading" class="status flex-center">
						<div class="loading"></div>
						<p>正在登录，请稍候...</p>
					</div>

					<div v-else-if="error" class="status error">
						<i class="tf">&#xe6a0;</i>
						<p>{{ error }}</p>
						<button @click="goLogin">返回登录页</button>
					</div>
				</div>
			</div>

			<div class="copyright">
				<p>浙江银江智能信息技术有限公司 提供技术支持</p>
				<p><span>平台客服邮箱：yjszbh@163.com</span><a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备19010525号-1</a></p>
			</div>
		</div>
	</div>
</template>

<script>
	import fun from '@/assets/script/function.js'

	export default {
		data() {
			return {
				loading: true,
				error: ''
			};
		},

		mounted() {
			const query = this.$route.query;
			const code = query.code;
			const errorParam = query.error;

			if (errorParam) {
				this.handleError('登录失败，请重试');
				return;
			}

			if (!code) {
				this.handleError('缺少授权码，请重新登录');
				return;
			}

			this.request({
				url: '/auth/tacs_sso/check',
				data: {
					code: code
				},
				loading: false,
				success: data => {
					// 后端已自动注册并登录，统一返回sessionId
					fun.setCookie('session_id', data.sessionId);
					this.$store.commit('setUserInfo', data.userInfo);
					if (data.needComplete) {
						this.navigateTo('/register');
					} else {
						this.navigateTo('/');
					}
				},
				fail: (code, obj, msg) => {
					this.$message({
						text: msg
					});
					this.navigateTo('/login');
				}
			});
		},

		methods: {
			handleError(msg) {
				this.loading = false;
				this.error = msg;
				setTimeout(() => {
					this.navigateTo('/login');
				}, 1500);
			},
			goLogin() {
				this.navigateTo('/login');
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.body {
		height: 100vh;
		overflow: hidden;
		background-color: #fff
		background-image: url('~@/assets/image/login/bg.jpg');
		background-position: top center;
		background-size: auto 611px;
		background-repeat: no-repeat;
	}

	.main {
		width: 950px;
		margin: 100px auto 0;
	}

	.logo {
		align-self: flex-start;
		height: 36px;
	}

	.login {
		width: 100%;
		height: 480px;
		border-radius: 18px;
		margin-top: 30px;
		background: rgba(255,255,255,.95);
		box-shadow: 0 0 10px 0 rgba(30,84,132,.2);

		.cover {
			width: 512px;
			height: 375px;
			border-right: 1px solid #eee;

			img {
				width: 440px;
			}
		}

		.form {
			padding: 0 48px;
			margin-bottom: 40px;
		}

		.title {
			gap: 8px;
			margin-bottom: 28px;
			font-size: 12px;
			color: #bbb;

			h1 {
				font-size: 26px;
				font-weight: normal
				color: #000;
			}
		}
	}

	.status {
		flex-direction: column;
		gap: 16px;
		margin-top: 60px;
		font-size: 16px;
		color: #666;

		.loading {
			width: 40px;
			height: 40px;
			border: 3px solid #eee;
			border-top-color: #1492FF;
			border-radius: 50%;
			animation: spin 1s linear infinite;
		}

		&.error {
			i {
				font-size: 48px;
				color: #ff4d4f;
			}

			button {
				display: block;
				width: 100%;
				height: 50px;
				border: none;
				border-radius: 25px;
				font-size: 20px;
				color: #fff;
				background: #1492FF;
				cursor: pointer;
				margin-top: 20px;

				&:hover {
					opacity: .9;
				}
			}
		}
	}

	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}

	.copyright {
		margin-top: 24px;
		line-height: 24px;
		font-size: 13px;
		color: #999;

		p {
			float: left;

			&:nth-child(2) {
				float: right;
			}

			span, a {
				margin-left: 1em;
				text-decoration: none;
			}

			a {
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
</style>
